import { render, staticRenderFns } from "./24_main.vue?vue&type=template&id=7f0acd06"
import script from "./24_main.vue?vue&type=script&lang=js"
export * from "./24_main.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports